import type { HTMLAttributes } from 'react';

export type LoadingType =
  | 'audio'
  | 'ball-triangle'
  | 'ballbounce'
  | 'bars'
  | 'circles'
  | 'grid'
  | 'hearts'
  | 'oval'
  | 'pacman'
  | 'puff'
  | 'rings'
  | 'spinning-circles'
  | 'tail-spin'
  | 'three-dots'
  | 'threedots';

export type LoadingColor = 'light' | 'dark';

export interface LoadingProps extends HTMLAttributes<HTMLImageElement> {
  type?: LoadingType;
  color?: LoadingColor;
}
